import campaignService from '../../../services/campaigns-service'

let LOAD_CAMPAIGN_DETAILS = 'LOAD_CAMPAIGN_DETAILS'
let LOAD_BATCH_RULE_SOURCE = 'LOAD_BATCH_RULE_SOURCE'
let CAMPAIGN_SAVED = 'CAMPAIGN_SAVED'
let CAMPAIGN_SAVE_STARTED = 'CAMPAIGN_SAVE_STARTED'
let CAMPAIGN_SAVE_ERROR = 'CAMPAIGN_SAVE_ERROR'

export function loadCampaignDetails(filter) {
  return (dispatch, getState) => {
    return campaignService.getCampaignDetails(filter)
      .then((campaignDetails) => {
        dispatch({
          type: LOAD_CAMPAIGN_DETAILS,
          campaignDetails: campaignDetails
        })
      })
  }
}

export function loadBatchRuleSource() {
  return (dispatch, getState) => {
    return campaignService.getBatchRuleSource()
      .then((batchRuleSource) => {
        dispatch({
          type: LOAD_BATCH_RULE_SOURCE,
          batchRuleSource: batchRuleSource
        })
      })
  }
}

export function saveCampaign(campaignInfo) {
  return (dispatch, getState) => {
    dispatch({
      type: CAMPAIGN_SAVE_STARTED
    })
    return campaignService.saveOrUpdateCampaign(campaignInfo)
      .then((campaignDetails) => {
        if (_.isEmpty(_.get(campaignDetails, 'errors'))) {
          console.log('---success---')
          dispatch({
            type: CAMPAIGN_SAVED,
            campaignDetails: campaignDetails
          })
        } else {
          console.log('--- error---')
          dispatch({
            type: CAMPAIGN_SAVE_ERROR
          })
        }
      })
  }
}

// --- Reducer --

export function campaignDetailsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_CAMPAIGN_DETAILS: {
      return action.campaignDetails
    }
    default:
      return state
  }
}

export function batchRuleSourceReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_BATCH_RULE_SOURCE: {
      return action.batchRuleSource
    }
    default:
      return state
  }
}

export function saveCampaignReducer(state = {}, action) {
  switch (action.type) {
    case CAMPAIGN_SAVE_STARTED: {
      return {loading: true, error: false}
    }
    case CAMPAIGN_SAVED: {
      return {campaignDetails: action.campaignDetails, loading: false, error: false}
    }
    case CAMPAIGN_SAVE_ERROR: {
      return {loading: false, error: true}
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/CampaignCreation/modles/CampaignCreation.js